import cmsHub from './cmsHub'

export default {
    _connection: null,
    async startConnection(handlers){
        this._connection = await cmsHub.startConnection("hub/testExpirationHub", handlers);
    },
    async stopConnection(){
        await this._connection.close();
    }
}